import jwtDecode from "jwt-decode";
import ReactGA from "react-ga4";
import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { PATH_EXTERNAL } from "../../routes/paths";
import { config } from "../../config";
import { resetAccountDialogs } from "./account";
import { resetWalletDialog } from "./wallet";
import { isWalletBrowser } from "../../utils/isMobile";
// ----------------------------------------------------------------------
const BASE_URL = config.BASE_API_URL;
const defaultHeader = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

const initialState = {
  transactionList: null,
  userStat: null
};

const slice = createSlice({
  name: "one",
  initialState,
  reducers: {
    setTransitionList(state, action) {
      state.transactionList = action.payload;
    },
    setUserStat(state, action) {
      state.userStat = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;
export const { setTransitionList, setUserStat } = slice.actions;

// ----------------------------------------------------------------------

export const getTransitionList = (page = 1) => {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/transaction/list?page=${page}&size=10`, {
        baseURL: BASE_URL
      });
      dispatch(setTransitionList(response.data.data));
    } catch (error) {
      console.error(error);
    }
  };
};

export const getUserInfo = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/user/info`, { baseURL: BASE_URL });
      dispatch(setUserStat(response.data?.data || {}));
    } catch (error) {
      console.error(error);
    }
  };
};
